<template>
  <div>
    <div class="search">
      <el-form :model="query">
        <div class="form-box">
          <el-form-item label="名称">
            <el-input v-model="query.name" placeholder="请输入名称" clearable />
          </el-form-item>
        </div>
      </el-form>
      <div>
        <a href="javascript:;" class="btn btn-search" @click="getList">
          <img src="../../../assets/tableImg/search.svg" alt="" />{{ $t('search.search') }}</a
        >
        <a href="javascript:;" class="btn btn-reset" @click="reset()">
          <img src="../../../assets/tableImg/reset.svg" alt="" />{{ $t('search.reset') }}</a
        >
      </div>
    </div>
    <div class="content-box">
      <div>
        <div>
          <buttonItem :buttonList="menuButtonList" @chooseClick="clickEvent"></buttonItem>
        </div>
      </div>

      <div class="public-el-table">
        <el-table
          v-loading="loading"
          fit
          :data="definitionList"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            label="流程编号"
            align="center"
            prop="deploymentId"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="流程标识"
            align="center"
            prop="key"
            :show-overflow-tooltip="true"
          />
          <el-table-column label="流程分类" align="center">
            <template slot-scope="scope">
              <el-button type="text">
                <span>{{ formatterCategory(scope.row.category) }}</span>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="流程名称" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-button type="text" @click="handleReadImage(scope.row.deploymentId)">
                <span>{{ scope.row.name }}</span>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="流程版本" align="center">
            <template slot-scope="scope">
              <el-tag size="medium">v{{ scope.row.version }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.suspensionState === 1">激活</el-tag>
              <el-tag type="warning" v-if="scope.row.suspensionState === 2">挂起</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="部署时间" align="center" prop="deploymentTime" width="180" />
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    icon="el-icon-edit-outline"
                    @click.native="handleLoadXml(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <!--<el-dropdown-item icon="el-icon-connection" @click.native="handleAddForm(scope.row)" v-if="scope.row.formId == null">-->
                  <!--  配置表单-->
                  <!--</el-dropdown-item>-->
                  <el-dropdown-item
                    icon="el-icon-video-pause"
                    @click.native="handleUpdateSuspensionState(scope.row)"
                    v-if="scope.row.suspensionState === 1"
                  >
                    挂起
                  </el-dropdown-item>
                  <el-dropdown-item
                    icon="el-icon-video-play"
                    @click.native="handleUpdateSuspensionState(scope.row)"
                    v-if="scope.row.suspensionState === 2"
                  >
                    激活
                  </el-dropdown-item>
                  <el-dropdown-item
                    icon="el-icon-delete"
                    @click.native="handleDelete(scope.row)"
                    v-hasPermi="['system:deployment:remove']"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <pagination
        :multipleSelection="ids"
        :total="queryParams.total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      ></pagination>
    </div>

    <!-- 流程图 -->
    <el-dialog :title="readImage.title" :visible.sync="readImage.open" width="70%" append-to-body>
      <!-- <el-image :src="readImage.src"></el-image> -->
      <flow :xmlData="xmlData" />
    </el-dialog>

    <!--挂载表单-->
    <el-dialog :title="formDeployTitle" :visible.sync="formDeployOpen" width="60%" append-to-body>
      <el-row :gutter="24">
        <el-col :span="10" :xs="24">
          <el-table
            ref="singleTable"
            :data="formList"
            border
            highlight-current-row
            @current-change="handleCurrentChange"
            style="width: 100%"
          >
            <el-table-column label="表单编号" align="center" prop="formId" />
            <el-table-column label="表单名称" align="center" prop="formName" />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="submitFormDeploy(scope.row)"
                  >确定</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <pagination
            :total="formTotal"
            :page.sync="formQueryParams.pageNum"
            :limit.sync="formQueryParams.pageSize"
            @pagination="ListFormDeploy"
          ></pagination>
          <!--<pagination-->
          <!--  small-->
          <!--  layout="prev, pager, next"-->
          <!--  v-show="formTotal>0"-->
          <!--  :total="formTotal"-->
          <!--  :page.sync="formQueryParams.pageNum"-->
          <!--  :limit.sync="formQueryParams.pageSize"-->
          <!--  @pagination="ListFormDeploy"-->
          <!--/>-->
        </el-col>
        <el-col :span="14" :xs="24">
          <div v-if="currentRow">
            <parser :key="new Date().getTime()" :form-conf="currentRow" />
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- bpmn20.xml导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xml"
        :action="upload.url + '?access_token=' + userInfo.userInfo.access_token"
        :data="{ name: upload.name, category: upload.category }"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或<span style="color: #00b400">点击上传</span>
        </div>
        <div class="el-upload__tip" slot="tip">
          <!--流程名称：<el-input v-model="upload.name"/>-->
          <!--流程分类：<el-input v-model="upload.category"/>-->
          流程分类：
          <el-select v-model="upload.category" placeholder="请选择">
            <el-option
              v-for="item in categorys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="el-upload__tip" style="color: red" slot="tip"
          >提示：仅允许导入“bpmn20.xml”格式文件！</div
        >
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import flow from '../task/record/flow';
  import buttonItem from '../../../components/ButtonItem';
  import pagination from '../../../components/pagination';
  import { mapState } from 'vuex';
  import baseUrl from '@/common/config';
  export default {
    name: 'flowableDefine',
    components: {
      flow,
      buttonItem,
      pagination,
    },
    data() {
      return {
        query: {
          name: '',
        },
        definitionList: [],
        ids: [], // 选中数组
        single: true, // 非单个禁用
        multiple: true, // 非多个禁用
        loading: false,
        readImage: {
          open: false,
          src: '',
        },
        xmlData: '',
        menuButtonList: [],
        formTotal: 0,
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          // total: 0
        },
        // 挂载表单到流程实例
        formDeployParam: {
          formId: null,
          deployId: null,
        },
        formQueryParams: {
          pageNum: 1,
          pageSize: 10,
        },
        formDeployOpen: false,
        formDeployTitle: '',
        formList: [],
        currentRow: null,
        // bpmn.xml 导入
        upload: {
          // 是否显示弹出层（xml导入）
          open: false,
          // 弹出层标题（xml导入）
          title: '',
          // 是否禁用上传
          isUploading: false,
          category: null,
          // 上传的地址
          url: baseUrl + '/maindata/flowable/definition/import',
        },
        categorys: [],
      };
    },
    mounted() {
      this.getButtons().then((e) => {
        this.menuButtonList = e;
      });
      this.$axios
        .post('/maindata/dictData/listDataDictByDataType', { dictType: 'ProcessType' })
        .then((res) => {
          this.categorys = res.data.data;
        });
      this.getList();
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    methods: {
      /** 查询流程定义列表 */
      getList() {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.queryParams,
        };
        this.$axios.get('/maindata/flowable/definition/list', params).then((response) => {
          this.definitionList = response.data.data.records;
          this.queryParams.total = response.data.data.total;
          console.log(this.queryParams.total);
          this.loading = false;
        });
      },
      // 多选框选中数据
      handleSelectionChange(selection) {
        this.ids = selection.map((item) => {
          return item.deploymentId;
        });
        this.single = selection.length !== 1;
        this.multiple = !selection.length;
      },
      /** 流程图查看 */
      handleReadImage(deploymentId) {
        this.readImage.title = '流程图';
        this.readImage.open = true;
        // this.readImage.src = process.env.VUE_APP_BASE_API + "/flowable/definition/readImage/" + deploymentId;
        // 发送请求，获取xml
        this.$axios.get(`/maindata/flowable/definition/readXml/${deploymentId}`).then((res) => {
          this.xmlData = res.data.data;
        });
      },
      /** 表单查看 */
      handleForm(formId) {
        this.$axios.get(`/maindata/flowable/form/${formId}`).then((res) => {
          this.formTitle = '表单详情';
          this.formConfOpen = true;
          this.formConf = JSON.parse(res.data.data.formContent);
        });
      },
      /** 跳转到流程设计页面 */
      handleLoadXml(row) {
        if (row) {
          this.$router.push({ path: '/flowable/model', query: { deployId: row.deploymentId } });
        } else {
          this.$router.push({ path: '/flowable/model' });
        }
      },
      /** 挂载表单弹框 */
      handleAddForm(row) {
        this.formDeployParam.deployId = row.deploymentId;
        this.ListFormDeploy();
      },
      /** 挂载表单列表 */
      ListFormDeploy() {
        this.$axios.get('maindata//flowable/form/list', this.formQueryParams).then((res) => {
          this.formList = res.data.rows;
          this.formTotal = res.data.total;
          this.formDeployOpen = true;
          this.formDeployTitle = '挂载表单';
        });
      },
      /** 挂载表单 */
      submitFormDeploy(row) {
        this.formDeployParam.formId = row.formId;
        this.$axios
          .post('/maindata/flowable/form/addDeployForm', this.formDeployParam)
          .then((res) => {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.formDeployOpen = false;
            this.getList();
          });
      },
      handleCurrentChange(data) {
        if (data) {
          this.currentRow = JSON.parse(data.formContent);
        }
      },
      /** 挂起/激活流程 */
      handleUpdateSuspensionState(row) {
        let state = 1;
        if (row.suspensionState === 1) {
          state = 2;
        }
        const params = {
          deployId: row.deploymentId,
          state: state,
        };
        this.$axios.put(`/maindata/flowable/definition/updateState`, params).then((res) => {
          this.$message({ showClose: true, message: res.data.msg, type: 'success' });
          this.getList();
        });
      },
      /** 删除按钮操作 */
      handleDelete(row, type) {
        // const ids = row.deploymentId || this.ids;
        if (type === 'selection' && this.ids.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        console.log(row);
        if (row.length > 1) {
          this.$message({
            showClose: true,
            message: '只能选择一条数据删除',
            type: 'error',
          });
          return;
        }
        const params = {
          // deployId: type === 'selection' ? this.ids :row.deploymentId
          deployId: row[0],
        };
        this.$confirm('是否确认删除流程定义编号为"' + params.deployId + '"的数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$axios.delete('/maindata/flowable/definition/delete', params);
            this.$message({ showClose: true, message: '删除成功', type: 'success' });
            this.getList();
          })
          .catch(() => {
            this.getList();
          });
      },
      /** 提交按钮 */
      submitForm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.form.id != null) {
              this.updateDeployment(this.form).then(() => {
                this.msgSuccess('修改成功');
                this.open = false;
                this.getList();
              });
            } else {
              this.addDeployment(this.form).then(() => {
                this.msgSuccess('新增成功');
                this.open = false;
                this.getList();
              });
            }
          }
        });
      },
      // 文件上传成功处理
      handleFileSuccess(response) {
        this.upload.open = false;
        this.upload.isUploading = false;
        this.upload.name = '';
        this.upload.category = '';
        this.$refs.upload.clearFiles();
        this.$message(response.msg);
        this.getList();
      },
      // 文件上传中处理
      handleFileUploadProgress() {
        this.upload.isUploading = true;
      },
      // 提交上传文件
      submitFileForm() {
        this.$refs.upload.submit();
      },
      /** 导出按钮操作 */
      handleExport() {
        const queryParams = this.queryParams;
        this.$confirm('是否确认导出所有流程定义数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(function () {
            return this.exportDeployment(queryParams);
          })
          .then((response) => {
            this.download(response.msg);
          });
      },
      clickEvent(item) {
        switch (item) {
          case 'add':
            this.handleLoadXml();
            break;
          case 'delete':
            this.handleDelete(this.ids, 'selection');
            break;
          case 'import':
            this.upload.title = 'bpmn20.xml文件导入';
            this.upload.open = true;
            break;
        }
      },
      reset() {
        for (let key in this.query) {
          this.query[key] = '';
        }
        this.getList();
      },
      formatterCategory(val) {
        let text = '';
        this.categorys.map((item) => {
          if (val === item.value) {
            return (text = item.label);
          }
        });
        return text;
      },
    },
  };
</script>

<style scoped lang="scss">
  .search {
    margin-bottom: 10px;
    padding: 0 30px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .form-box {
      display: flex;
      .el-form-item {
        width: 320px;
        margin-left: 20px;
        margin-top: 18px;
        ::v-deep .el-form-item__label {
          width: 80px;
        }
        ::v-deep .el-form-item__content {
          margin-left: 80px;
        }
        ::v-deep .el-select {
          width: 100%;
        }
        ::v-deep .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }
      }
      .item {
        display: flex;
        flex-wrap: wrap;
      }
    }

    .btn {
      width: 90px;
      height: 30px;
      display: inline-block;
      line-height: 30px;
      text-align: center;
      border-radius: 3px;
      img {
        vertical-align: middle;
        padding-right: 10px;
      }
    }

    .btn-search {
      background-color: #409eff;
      color: #ffffff;
    }
    .btn-reset {
      background-color: #ffffff;
      color: #409eff;
      border: 1px solid #e4e6eb;
    }
  }

  .content-box {
    padding: 20px 30px;
    background-color: #ffffff;
  }
  ::v-deep .el-button--text {
    color: #00b400;
  }
  ::v-deep .el-select {
    width: 80%;
  }
  ::v-deep .popper__arrow:after {
    border-bottom-color: #fff !important;
  }
</style>
